import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { request, gql } from "graphql-request";
import { hyGraphToken, endpointURL } from "../ThemeModule";
import Seo from "../components/Seo";
import { ROUTE_META } from "../seo/siteMeta.mjs";

const titleVariants = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -100 },
};

const PrivacyPolicy = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      const query = gql`
        query privacyPolicy($slug: String!) {
          page(where: { slug: $slug }) {
            title
            slug
            content {
              html
            }
          }
        }
      `;

      const headers = {
        Authorization: `Bearer ${hyGraphToken}`,
      };

      try {
        const data = await request(
          endpointURL,
          query,
          { slug: "privacy-policy" },
          { headers }
        );
        setPage(data.page);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, []);

  const title = page ? page.title : "Privacy Policy";

  return (
    <>
      <Seo
        path="/privacy-policy"
        title={ROUTE_META["/privacy-policy"].title}
        description={ROUTE_META["/privacy-policy"].description}
      />

      <div className="contact-page-header page-header">
        <img
          src={"https://us-west-2.graphassets.com/clwj6ln45017c07n38hgpctal/cm793xde61la907lgir65fnv8"}
          alt="Privacy Policy"
          className="img-fluid"
        />
        <div className="max-w-container mx-auto px-4 pt-24">
          <div className="text-center text-white">
            <motion.h1
              variants={titleVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ type: "spring", duration: 1 }}
              className="text-100 font-medium"
            >
              {title}.
            </motion.h1>
            <motion.div
              variants={titleVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ type: "spring", duration: 1.2 }}
            >
              <Link to="/" className="text-white hover:underline">
                Home
              </Link>
              <span className="mx-5">|</span>
              <span className="text-primary">{title}</span>
            </motion.div>
          </div>
        </div>
        <div className="page_header_overlay"></div>
      </div>
      <section className="page-section sub-bg relative shape-1 shape-2">
        <div className="max-w-container mx-auto px-4">
          {loading ? (
            <div className="loader text-center">Loading...</div>
          ) : error ? (
            <div className="error-message text-red-500 text-center">
              <p>Failed to load Privacy Policy: {error}</p>
            </div>
          ) : (
            page && (
              <div className="mx-auto flex flex-wrap lg:px-5 lg:-mx-4">
                <div className="w-full px-4">
                  <div className="page_content relative">
                    {page.content?.html && (
                      <div
                        dangerouslySetInnerHTML={{
                          // Strip stray <br> tags from the CMS content so text
                          // reflows to fill the full width instead of breaking
                          // mid-sentence at half width.
                          __html: page.content.html.replace(/<br\s*\/?>/gi, " "),
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
